var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.001,
    viewBox: "0 0 24.001 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Chart",
    "data-name": "Iconly/Bold/Chart",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M17.6,0c4.081,0,6.385,2.315,6.4,6.4h0V17.6c0,4.08-2.316,6.4-6.4,6.4H6.4C2.315,24,0,21.685,0,17.6H0V6.4C0,2.315,2.315,0,6.4,0H17.6Zm-5,4.956a1.008,1.008,0,0,0-1.537.948h0V18.133a1.011,1.011,0,0,0,1,.9.992.992,0,0,0,1-.9h0V5.9A.979.979,0,0,0,12.6,4.957ZM7,8.893a.988.988,0,0,0-1.056,0,1.009,1.009,0,0,0-.468.948h0v8.292a1,1,0,0,0,1.991,0h0V9.841A1.01,1.01,0,0,0,7,8.893Zm11.111,4.356a1.006,1.006,0,0,0-1.067,0,.967.967,0,0,0-.456.948h0v3.936a.992.992,0,0,0,1,.9,1.011,1.011,0,0,0,1-.9h0V14.2A1,1,0,0,0,18.108,13.249Z",
    transform: "translate(0 0)",
    fill: "#3062ac"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.64935db063ea2edc56fa41d5c5c57906.svg";
export { ForwardRef as ReactComponent };